module.exports = __webpack_public_path__ + "resources/img/img_maxgauge2_m.55c17239a11c4d0dae5e7fd0cb1f7409.png";